module.exports = __webpack_public_path__ + "static/media/S1N12.4d5e5069.svg";